export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-photos-item.vue?vue&type=template&id=b0117364&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-photos-item/lk-photos-item.vue?vue&type=template&id=b0117364&
// module id = 1400
// module chunks = 0